import { render, staticRenderFns } from "./GoodsDialog.vue?vue&type=template&id=360114e8&scoped=true&"
import script from "./GoodsDialog.vue?vue&type=script&lang=js&"
export * from "./GoodsDialog.vue?vue&type=script&lang=js&"
import style0 from "./GoodsDialog.vue?vue&type=style&index=0&id=360114e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360114e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360114e8')) {
      api.createRecord('360114e8', component.options)
    } else {
      api.reload('360114e8', component.options)
    }
    module.hot.accept("./GoodsDialog.vue?vue&type=template&id=360114e8&scoped=true&", function () {
      api.rerender('360114e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/advertisingSpace/components/GoodsDialog.vue"
export default component.exports